import React from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import InvoiceTableRow from '@aytm/lib/rfd-ui/components/payment/invoice-table/row'

export default class InvoiceTablePromoRow extends InvoiceTableRow {
  static propTypes = {
    row: PropTypes.instanceOf(Map).isRequired,
    width: PropTypes.number,
    valuesWidth: PropTypes.number
  }

  render() {
    const { row, width, valuesWidth } = this.props
    const tableWidth = width && valuesWidth ? width + valuesWidth : null

    return (
      <div className="rfd-ui-invoice-table-promo-block" style={{ width: tableWidth }}>
        <div className="rfd-ui-invoice-table-promo-label">
          <i className={`rfd-ui-invoice-table-promo-icon ${row.get('icon')}`} />
          <div dangerouslySetInnerHTML={{ __html: this.preprocessText(row.get('label')) }} />
        </div>
        <div
          className="rfd-ui-invoice-table-promo-text"
          dangerouslySetInnerHTML={{ __html: this.preprocessText(row.get('text')) }}
        />
      </div>
    )
  }
}
